import React from 'react';
import { colors } from './theme';
import { analyticsCardStyles as card } from './analytics/analyticsCardStyles';

export default function MtbfAnalyticsCard({ data, failureCount }) {
  const totalTime = typeof data?.totalOperatingTime === 'number' ? data.totalOperatingTime : 0;
  const totalFailures = Number(data?.allTimeAcceptedNin ?? failureCount ?? 0);
  const mtbfHours = totalFailures > 0 ? totalTime / totalFailures : null;
  const mtbfYears = mtbfHours !== null ? mtbfHours / 8760 : null;
  const devices = Array.isArray(data?.devices) ? data.devices : [];

  return (
    <div style={{ ...card.shell, maxWidth: '760px' }}>
      <div style={card.header}>
        <div style={card.titleWrap}>
          <p style={card.eyebrow}>Reliability</p>
          <h2 style={card.title}>Mean Time Between Failures</h2>
        </div>
      </div>
      <div style={card.body}>
        <div style={{ textAlign: 'center', color: colors.textStrong, fontSize: '1.8rem', fontWeight: 700 }}>
          {mtbfHours !== null
            ? `MTBF: ${Math.round(mtbfHours).toLocaleString()} hours (~ ${Math.round(mtbfYears).toLocaleString()} years)`
            : 'MTBF: N/A'}
        </div>

        <div style={{ ...card.section, marginTop: '1rem', fontFamily: 'monospace' }}>
          <div><strong>Total Operating Time (Fleet):</strong> {totalTime.toFixed(0)} hours</div>
          <div><strong>All-Time Warranty Accepted by NIN:</strong> {totalFailures}</div>
        </div>

        <div style={{ ...card.section, marginTop: '1rem' }}>
          <div style={{ fontWeight: 600, color: colors.textStrong }}>Formula</div>
          <div style={{ fontFamily: 'monospace', marginTop: '0.25rem' }}>
            MTBF (Fleet) = Total Operating Time (Fleet) / All-Time Warranty Accepted by NIN
          </div>
          <div style={{ marginTop: '0.25rem', fontSize: '0.9rem', color: colors.textMuted }}>
            Field-observed MTBF based on cumulative fleet hours. This assumes units remain in service until failure is reported.
          </div>
        </div>

        <div style={{ ...card.section, marginTop: '1rem' }}>
          <div style={{ fontWeight: 600, color: colors.textStrong }}>Device Operating Times</div>
          <ul style={{ marginTop: '0.35rem', color: colors.textBody }}>
            {devices.length > 0 ? devices.map(device => (
              <li key={device.serialNumber}>
                {device.serialNumber}: {Number(device.operatingHours).toFixed(0)} h
              </li>
            )) : <li>None</li>}
          </ul>
        </div>
      </div>
    </div>
  );
}
